import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import { headingStyles, typographyTheme } from '~typography';
var CurrentPrice = styled.span.withConfig({
  displayName: "CurrentPrice",
  componentId: "sc-5cnkof-0"
})(["  ", " font-size:", ";"], headingStyles, function (_ref) {
  var theme = _ref.theme;
  return rem(_get(theme, 'typography.headings.fontSize.h1', typographyTheme.typography.headings.fontSize.h1));
});
export default CurrentPrice;